import { useResourceHistory } from './use-resource-history';

/**
 * ViewModel for the Agents detail revision history. Thin wrapper around the
 * generic `useResourceHistory`.
 */
export function useAgentHistory(
  agentId: string | null,
  options: { enabled?: boolean } = {},
) {
  return useResourceHistory('agent', agentId, options);
}
